export const uk = {
    cancel: 'Отмена'
};
